const ITEMS = [
  "Doctor-ordered",
  "Delivered at home",
  "Outcome-reported",
  "No commissions, ever",
  "Verified clinicians",
  "Live in India — Malaysia next",
];

const Row = ({ hidden = false }) => (
  <div aria-hidden={hidden} className="flex items-center gap-10 pr-10">
    {ITEMS.map((t) => (
      <span
        key={t}
        className="flex items-center gap-10 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.3em]"
      >
        {t}
        <svg width="7" height="7" viewBox="0 0 8 8" aria-hidden="true">
          <rect
            x="1.2"
            y="1.2"
            width="5.6"
            height="5.6"
            transform="rotate(45 4 4)"
            fill="#D2A62E"
          />
        </svg>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee relative z-10 overflow-hidden bg-ink py-4 text-mint"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
